import get from 'lodash/get';
import camelCase from 'lodash/camelCase';

const getErrorMessages = (formType, errors, translations) => {
  const translatedErrors = errors.reduce((result, err) => {
    const errorType = camelCase(err.type.split('.').pop());
    const key = err.context.key;

    let translationKey = key;
    switch (formType) {
      case 'adventurer': {
        translationKey = ['book', formType, key, errorType].join('.');
        break;
      }
      default:
        translationKey = [translationKey, errorType].join('.');
    }

    let defaultTranslations = get(translations, ['general', errorType]) || err.message;
    let prismicTranslation = get(translations, translationKey) || defaultTranslations;

    result[key] = result[key] || prismicTranslation;
    return result;
  }, {});
  return translatedErrors;
};

export default getErrorMessages;



// WEBPACK FOOTER //
// ./src/common/utils/error-messages.js